module.exports = __webpack_public_path__ + "img/header.78c42112.jpg";